import { isMobile, isTablet, isDesktop } from '../Utils';

/* Youtube Api has to be global */
window.YouTubePropsDictionary = {};

window.onYouTubeIframeAPIReady = function () {
    Object.entries(window.YouTubePropsDictionary).forEach(([key, val]) => {
        /* eslint-disable-next-line */
        window.YouTubePropsDictionary[key].player = new YT.Player(val.YoutubeClientID, {
            host: 'https://www.youtube-nocookie.com',
            events: {
                'onReady': window.onPlayerReady,
            },
            playerVars: {
                rel: 0
            }
        });
    });
};

window.onPlayerReady = function (event) {
    if (window.YouTubePropsDictionary[event.target.h.id].muted) event.target.mute();
    if (window.YouTubePropsDictionary[event.target.h.id].autoPlay) {
        event.target.playVideo();
    }
};

window.InitYoutubeAutoplayVideo = function (containerId, muted, desktopWidth, tabletWidth, mobileWidth) {
    let autoPlay = true;

    if (isMobile() && mobileWidth <= 0) {
        autoPlay = false;
    }
    else if (isTablet() && tabletWidth <= 0) {
        autoPlay = false;
    }
    else if (isDesktop() && desktopWidth <= 0) {
        autoPlay = false;
    }

    window.YouTubePropsDictionary[containerId] = { muted, autoPlay, YoutubeClientID: containerId };

    const tag = document.createElement('script');
    tag.id = `APIScriptFor_${containerId}`;
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};
